import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`accounts-payable-accountant/dashboard?${query}`)
  }
}

export default DashboardService
